import { myAxios } from "./axios";

export function getInvoices({ filters }, { page, perPage }) {
  let config = {
    params: {
      page,
      perPage,
      ...(filters || {}),
    },
  };
  return myAxios.get("/invoices", config);
}
export function getContractInvoices(
  { contractId, filters },
  { page, perPage }
) {
  let config = {
    params: {
      page,
      perPage,
      ...(filters || {}),
    },
  };
  return myAxios.get("/company-contracts/" + contractId + "/invoices", config);
}

export function getInvoice(id) {
  return myAxios.get("/invoices/" + id);
}

export function getInvoicePreview(contractId) {
  return myAxios.get("/invoices/" + contractId + "/preview");
}

export function addInvoice(data) {
  return myAxios.post("/invoices/create", data);
}

export function payInvoice(id, data) {
  return myAxios.post("/invoices/" + id + "/update", data);
}

export function deleteInvoice(id) {
  return myAxios.delete("/invoices/" + id + "/delete");
}

export function sendEmail(data) {
  return myAxios.post("/invoices/send-mail", data);
}
export function sendInvoicesEmail(data) {
  return myAxios.post("/invoices/bulk-send", data);
}

export function getInvoicePdf(id, data) {
  return myAxios.post("/invoices/" + id + "/create-pdf", data, {
    responseType: 'blob'
  });
}
export function getDutchInvoicePdf(id, data) {
  return myAxios.post("/invoices/" + id + "/create-dutch-pdf", data, {
    responseType: 'blob'
  });
}
